export enum InvestigationRespondentRequestDecision {
	Accept = 1,
	Reject = 2,
}
